import { FCX } from "@datassential/platform-ui-lib";
import { useEffect } from "react";
import SelectAmong, { SelectAmongProps } from "@vms/SelectAmong/SelectAmong";
import {
    SelectAmongContextProvider,
    SelectAmongData,
    useSelectAmongContext
} from "@vms/SelectAmong/SelectAmongContext";
import { AmongPayload } from "@vms/SelectAmong/useGetAmongPayload";

export type SelectAmongWithContextProps = SelectAmongProps & {
    onPayloadChange?: (payload: AmongPayload) => void;
    onCopyTableTextChange?: (text: string | null) => void;
    onDataChange?: (data: SelectAmongData) => void;
    initialData?: Partial<SelectAmongData>;
};

const SelectAmongWithSeparatedContext: FCX<SelectAmongWithContextProps> = ({
    onPayloadChange,
    onCopyTableTextChange,
    onDataChange,
    ...props
}) => {
    const { data, amongPayload, amongCopyTableText } = useSelectAmongContext();

    // Call callbacks when payload or copy table text changes
    useEffect(() => {
        if (onPayloadChange) {
            onPayloadChange(amongPayload);
        }
    }, [amongPayload, onPayloadChange]);

    useEffect(() => {
        if (onCopyTableTextChange) {
            onCopyTableTextChange(amongCopyTableText);
        }
    }, [amongCopyTableText, onCopyTableTextChange]);

    useEffect(() => {
        if (onDataChange) {
            onDataChange(data);
        }
    }, [data, onDataChange]);

    return (
        <SelectAmong {...props}/>
    );
};

const SelectAmongWithContext: FCX<SelectAmongWithContextProps> = ({
    onPayloadChange,
    onDataChange,
    onCopyTableTextChange,
    initialData,
    children,
    ...props
}) => {
    return (
        <SelectAmongContextProvider initialData={initialData}>
            <SelectAmongWithSeparatedContext
                onPayloadChange={onPayloadChange}
                onCopyTableTextChange={onCopyTableTextChange}
                onDataChange={onDataChange}
                {...props}
            />
            {children}
        </SelectAmongContextProvider>
    );
};

export default SelectAmongWithContext;
